import MicroModal from 'micromodal';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        MicroModal.init();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
